/**
 * Created by Paul on 6/5/2017.
 */
import {Component, Input} from '@angular/core';
import {SixMarkBaseComponent} from "../sixMarkBase";
import {LotteryPage} from "../../../pages/lottery/lottery";

@Component({
  selector: 'sm-special-49-numbers',
  templateUrl: './sixmarkSpecial49Numbers.html',
  styleUrls: [ '/sixmarkSpecial49Numbers.scss' ]
})

/**
 * mname: SM04
 * The game allows user to bet a number in range 0 and 49
 * User can use button options to quickly pick special numbers
 */
export class SixMarkSpecial49NumbersComponent extends SixMarkBaseComponent{
  // List of button options which has 5 types as below
  btnOptions = [];
  // List of numbers - each has value and betCoins
  numbers = [];
  // Enum of button option types
  btnOptionTypes = {
    all: 'all',
    big: 'big',
    small: 'small',
    even: 'even',
    odd: 'odd'
  };

  @Input() bigBasedNumber: string;
  @Input()
  set selectOption(selectOption: any) {
    if (selectOption) {
      this.btnOptions = selectOption.no.btnOptions;

      // init numbers
      this.numbers = this.initNumbersArray(selectOption.no.number);

      this.maxAmountPerOption = selectOption.no.maxAmountPerOption;
      this.maxAmountPerBet = selectOption.no.maxAmountPerBet;
      this._selectOption = selectOption;
    }
  }

  /**
   * Set active to selected button option
   * @param type: button option type
   */
  setSelectedOption(type: string) {
    this.btnOptions.forEach(option => {
      if (option.type === type) {
        option.isActive = true;
      } else {
        option.isActive = false;
      }
    });
  }

  /**
   * Set selected to numbers of input array
   * @param numbers: An array of integers
   */
  setSelectedNumbers(numbers = []) {
    numbers.forEach(number => {
      this.addDefaultBetCoin(this.numbers[number - 1]);
    });
  }

  /**
   * Set selected number
   * @param number: an object with props: value and betCoins
   */
  setSelectedNumber(number) {
    if (number) {
      this.addDefaultBetCoin(number);

      // Set selected number to current bet
      this.setCurrentBets([number.value]);

      // Trigger popup
      this.onOptionSelected.emit();
      LotteryPage.clickPlay();
    }
  }

  /**
   * Reset all status to the beginning of the game
   */
  resetGame() {

    // Reset numbers status
    this.resetBetCoins(this.numbers);

    // Reset total
    this.onTotalChanged.emit(0);
  }

  /**
   * Remove a specific bets
   * @param bets
   */
  removeBets(bets = []) {
    bets.forEach(number => {
      if (number > 0 && number <= this.numbers.length) {
        // Remove the last item from bet coins array
        this.numbers[number - 1].betCoins.pop();
      }
    });
  }

  /**
   * Get an option by its code
   * @param optionCode
   */
  getOptionByCode(optionCode): any {
    return this.numbers[optionCode - 1];
  }
}



// WEBPACK FOOTER //
// ./src/component/sixmark/special49Numbers/sixmarkSpecial49Numbers.ts